import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade';
import {Link} from 'react-router-dom'
import {MdCardGiftcard} from 'react-icons/md'
import { Card, Row, Col } from 'antd';

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from 'swiper';


export default function Scoupon({brands, sAllCoupons}) {
  console.log(brands)
  console.log(sAllCoupons)


    return (
        // <ScouponWrap className="container py-sm-3">
          <Row gutter={30} className='md:h-80 h-40' >
            <Swiper
        slidesPerView={1}
        spaceBetween={10}
        loop={true}
        loopFillGroupWithBlank={true}
        grabCursor={true}        
        autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          "@0.00": {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          "@0.75": {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          "@1.00": {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          "@1.50": {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        }}
        modules={[Pagination, Autoplay]}
        className="mySwiper"
      >    

              {
                  brands.map((item, i)=>{

                    let arrLength = sAllCoupons && sAllCoupons.filter((it)=>{
                        return it?.brand?._id === item._id
                    })
                
                    console.log({arrLength});

                    return <>
                    
                    { 
                        arrLength && arrLength.length > 0 && <SwiperSlide><div  className="my-3  md:mx-6 mx-4 md:w-[255px] w-[144px] border-white md:rounded-3xl rounded-xl  z-80 md:shadow-2xl shadow-xl" >
                           
                           <Fade   duration={2000}>
                            <Link className=" " to={`/socialcoupon/${item._id}`}>
                    <div > 

                    {/* <MdCardGiftcard style={{fontSize:"5rem"}} className="mx-auto d-block text-warning" /> */}
                     {
                     item?.image? <img src={item?.image }  className="md:my-[24px] my-[4px] md:h-[140px] h-[80px] object-cover w-full "  alt="imglogo" />
                      : 
                      <span className="md:my-[24px] my-[4px] md:h-[140px] h-[80px] object-cover w-full " >
                         <MdCardGiftcard className="voucher text-center"/>&nbsp;  
                         </span>                    
                    }
                      
  

                   {/* <hr/> */}
               
                      <h6 className="bg-[#9a4c9d] text-center md:rounded-b-3xl rounded-b-xl  text-white md:pt-3 mb-0 text-[14px] mt-[5px] md:h-12 h-6 " >{item.name}</h6>

                    </div>
                    </Link>
                        </Fade>

                    </div>
                    </SwiperSlide>
                    }
                    </>

                  })
              }
              </Swiper>   
             
          </Row>

        // </ScouponWrap>
    )
}

// const ScouponWrap = styled.div`

// hr{

//     height:2px;
//     border-bottom:2px solid white;
//     /* border-style:dashed; */
//     margin:0.5rem auto;
// }

// .load{

//  text-align:center;
//  margin:auto;
//  display:block;

// }

// .voucher{

// color:orange;
// font-size:5rem;

// }
// `